// Project Card IDs (for Overview tab in ProjectDetailPage)
export const PROJECT_CARD_IDS = {
  scopeOfWork: "scopeOfWork",
  confidentialInformation: "confidentialInformation",
  startTime: "startTime",
  tasks: "tasks",
  requirements: "requirements",
  additionalSettings: "additionalSettings",
  workSite: "workSite",
  manager: "manager",
  notesBetweenCustomerAndAdmin: "notesBetweenCustomerAndAdmin",
  meta: "meta",
} as const;

export const PROJECT_CARD_LABELS: Record<string, string> = {
  [PROJECT_CARD_IDS.scopeOfWork]: "Scope of Work",
  [PROJECT_CARD_IDS.confidentialInformation]: "Confidential Information",
  [PROJECT_CARD_IDS.startTime]: "Start Time",
  [PROJECT_CARD_IDS.tasks]: "Tasks",
  [PROJECT_CARD_IDS.requirements]: "Requirements",
  [PROJECT_CARD_IDS.additionalSettings]: "Additional Settings",
  [PROJECT_CARD_IDS.workSite]: "Work Site",
  [PROJECT_CARD_IDS.manager]: "Manager",
  [PROJECT_CARD_IDS.notesBetweenCustomerAndAdmin]: "Notes Between Customer and Admin",
  [PROJECT_CARD_IDS.meta]: "Meta",
};

// Default order for project overview page (matching the original layout order)
export const DEFAULT_PROJECT_CARD_ORDER = [
  PROJECT_CARD_IDS.scopeOfWork,
  PROJECT_CARD_IDS.confidentialInformation,
  PROJECT_CARD_IDS.startTime,
  PROJECT_CARD_IDS.tasks,
  PROJECT_CARD_IDS.requirements,
  PROJECT_CARD_IDS.additionalSettings,
  PROJECT_CARD_IDS.workSite,
  PROJECT_CARD_IDS.manager,
  PROJECT_CARD_IDS.notesBetweenCustomerAndAdmin,
  PROJECT_CARD_IDS.meta,
];

